import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import {AppBar, Toolbar} from '@mui/material';
import {baseName} from 'src/config/keys';
const logoUri = `${baseName}/images/logos/logo_dscont_whiteH50.png`;


const Topbar = props => {
   const {className, ...rest} = props;

   return (
      <AppBar
         {...rest}
         className={className}
         color="primary"
         position="fixed"
         sx={{boxShadow: 'none'}}
      >
         <Toolbar>
            <RouterLink to="/">
               <img alt="Logo" src={logoUri} />
            </RouterLink>
         </Toolbar>
      </AppBar>
   );
};

Topbar.propTypes = {
   className: PropTypes.string
};

export default Topbar;
